// お知らせ管理で使用する定数を定義する
import { ListHeaderCellType } from 'views/components/atoms/listCell';
import { ListHeaderType } from 'views/components/molecules/listHeader';

// 表示するお知らせデータの型
export type NoticeData = {
  // お知らせID
  Id: string;
  // // 件名
  Title: string;
  // 配信区分
  DeliveryType: number;
  // 配信対象
  DeliveryTarget: number;
  // 口座番号
  Account: string;
};

/**
 * お知らせ一覧の取得後のResponseの型
 * useGetNoticeListで使用する
 *
 */
export type NoticeListResponse = {
  total: number;
  // お知らせリストデータ
  notices: NoticeData[];
};

/**
 * お知らせ詳細取得後のResponseの型
 * useGetNoticeDetailで使用する
 */
export type NoticeDetailResponse = {
  // 件名
  title: string;
  // 区分
  category: string;
  // 確認日
  confirmationDate: string;
  // 配信対象
  deliveryTarget: string;
  // 口座番号
  accountNumber: string[];
  // 掲載開始日 / 掲載終了日
  publicationStartDate: string;
  publicationEndDate: string;
  // 内容
  content: string;
};

export type NoticeEditInitValue = {
  title: string;
  category: string;
  confirmationDate: {
    year: string;
    month: string;
    day: string;
  };
  deliveryTarget: string;
  accountNumber: string;
  publicationStartDate: {
    year: string;
    month: string;
    day: string;
  };
  publicationEndDate: {
    year: string;
    month: string;
    day: string;
  };
  content: string;
};

/**
 * お知らせ一覧取得リクエストパラメータ
 */
export type GetNoticeListRequestRaram = {
  // ページ
  count?: number;
  // 1ページあたりの表示件数
  page?: number;
  // 件名
  title?: string;
  // 配信区分
  deliveryType?: number;
  // // 配信対象
  deliveryTarget?: number;
};

const NoticeHeaderShowList: ListHeaderType[] = [
  {
    type: ListHeaderCellType.textCell,
    label: '',
  },
  {
    type: ListHeaderCellType.textCell,
    label: '送信者',
  },
  {
    type: ListHeaderCellType.sentenceCell,
    label: '件名',
  },
  {
    type: ListHeaderCellType.textCell,
    label: '確認状態',
  },
  {
    type: ListHeaderCellType.textCell,
    label: '掲載日',
  },
];

export const getNoticeHeaderShowList = (needConfirmStatus: boolean): ListHeaderType[] =>
  NoticeHeaderShowList.filter((x) => !(!needConfirmStatus && x.label === '確認状態'));

export const DeliveryTypes = ['全て', 'FPG証券', 'FPG信託'];

export const DeliveryTargets = ['全て', '全体', '個別'];

export const DisabledOptions = ['区分', '配信対象'];

export enum NoticeEditModeType {
  Create = 'create',
  Edit = 'edit',
  Delete = 'delete',
}

export type NoticeEditMode = {
  mode: NoticeEditModeType;
};

export type PostCreateOrEditNoticeRequest = {
  // お知らせID
  noticeId: string;
  category: string;
  deliveryTarget: string;
  title: string;
  content: string;
  accountNumber: string[];
  publicationStartDate: string;
  publicationEndDate: string;
};
